<template>
  <BaseModal ref="baseModalRef" v-bind="childProps">
    <template v-slot:body>
      <div class="search-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="아이디">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.user_id" @inputKeyupEnter="onUserSearch()"/>
                    </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="성명">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.user_nm" @inputKeyupEnter="onUserSearch()"/>
                    </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="사번">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.employee_id" @inputKeyupEnter="onUserSearch()"/>
                    </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="부서">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.dept_nm" @inputKeyupEnter="onUserSearch()"/>
                    </template>
                </ElLabel>
            </div>
          </div>
        </div>
      </div>
      <div class="search-detail-wrap"></div>
      <div class="text-end py-2">
          <ElButton type="search" @buttonClick="onUserSearch()">검색</ElButton>
      </div>
      <div class="table-responsive table-list">
        <DataTable
          :value="state.gridUserData"
          v-model:selection="state.selectedUsers" dataKey="user_seq"
          paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
          scrollable scrollHeight="400px"
          stripedRows
        >
          <template #empty>
            <div class="center">데이터가 존재하지 않습니다.</div>
          </template>
          <Column :selectionMode="state.selection" headerStyle="width: 3rem"></Column>
          <Column field="employee_id" header="사번" style="min-width:4rem;"></Column>
          <Column field="user_id" header="아이디" style="min-width:15rem"></Column>
          <Column field="user_nm" header="성명" style="min-width:8rem"></Column>
          <Column field="dept_nm" header="부서" style="min-width:8rem"></Column>
          <Column field="email" header="이메일" style="min-width:15rem;"></Column>
          <Column field="mobile" header="핸드폰" style="min-width:8rem"></Column>
        </DataTable>
      </div>
    </template>
  </BaseModal>

</template>

<script setup>
import { reactive,ref,onBeforeMount } from 'vue';
import api             from '@/utils/api';
import common          from '@/js/common';
import DataTable       from 'primevue/datatable';
import Column          from 'primevue/column';
import BaseModal from './BaseModal.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { userSearch } from '@/api/userInfo';
const emits = defineEmits(['return']);

const closeUserModal = ref();
const baseModalRef = ref()


const childProps = ref({
  modalId : 'user',
  modalNm : '사용자 검색',
  size : 'lg',
  btnList : [
    {name:'선택', classNm : 'modelFooterConfirm',function:doSelectedUsers}
  ]
})
const state = reactive({
  gridUserData :[],
  selectedUsers :[],
  searchParams : {
    user_id : '',
    user_nm : '',
    employee_id : '',
    dept_nm : ''
  },
  selection: 'single'
});

onBeforeMount(()=>{
  onUserSearch()
})

/** 사용자 검색 */
async function onUserSearch(){
  try {
    setIsLoading(true)
    const res = await userSearch(state.searchParams)
    state.gridUserData = res.rtn
  } catch (err) {
    alert("전송 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};

/** 사용자 선택 */
function doSelectedUsers(){
  const selectedUsers = state.selectedUsers;
  if(common.isNotEmpty(selectedUsers)) {
      baseModalRef.value.closeModal()
      emits('return', selectedUsers);
  } else {
      alert('선택된 사용자가 없습니다.');
  }
};

/** 사용자 모달 열기 */
function openUserModal(isMultiple = true){
  state.selection = (isMultiple ? 'multiple' : 'single');
  state.selectedUsers = [];

  // baseModalRef.value.openModal() 
  const modal = new bootstrap.Modal(document.getElementById('user'));
  modal.show();
};

defineExpose({
  openUserModal
});

</script>
